<template>
    <div class="mainbody modulewrap">
        <div class="banner">
            <div class="bannerimg"><img :src="infodata.banner" /></div>
            <div class="csite"><div class="info realwrap"><router-link to="/">{{$common.dicword('homepage')}}</router-link><span>&gt;</span><span>{{$common.langinfo(infodata.title,infodata.title_en)}}</span></div></div>
        </div>
        <div class="collegeslogan">
            <div class="con">
                <span v-html="$common.langinfo(infodata.content,infodata.content_en)"></span>
                <div class="loganicon"><img :src="sloganicon" /></div>
            </div>
        </div>
        <div class="infowrap">
            <div class="infobox" v-for="item in infolist" :key="item.id">
                <div class="maintitle realwrap"><div class="word"><span>{{$common.langinfo(item.title,item.title_en)}}</span></div></div>
                <div class="project realwrap">
                    <div class="levellist">
                        <ul>
                            <li v-for="(item2,index2) in item.x_children" :key="item2.id">
                                <dl :class="{cs:item.x_index==index2}" @click="item.x_index=index2">
                                    <dt></dt>
                                    <dd class="a" :title="$common.langinfo(item2.title,item2.title_en)">{{$common.langinfo(item2.title,item2.title_en)}}</dd>
                                    <dd class="b"></dd>
                                </dl>
                            </li>
                        </ul>
                    </div>
                    <div class="courselist">
                        <router-link :to="'/course/'+item2.id" v-for="(item2,index2) in item.x_children[item.x_index].x_children" :key="item2.id">
                            <dl>
                                <dt><span class="word">{{$common.basic.padleft(index2+1)}}</span><span class="line"></span></dt>
                                <dd class="a"><img :src="item2.cover" /></dd>
                                <dd class="b" v-html="$common.langinfo(item2.title,item2.title_en)"></dd>
                                <dd class="c"><span>{{$common.dicword('viewmore')}}</span></dd>
                            </dl>
                        </router-link>
                    </div>
                </div>

            </div>

        </div>

    </div>
</template>

<script>
    export default {
        name: 'college',
        data() {
            return {
                infodata: {},
                sloganicon: '',
                infolist: []
            };
        },
        mounted() {

            let alias = this.$route.params.sub;
            this.$common.fetch({ 'act': 'tea_college', 'exts': 'alias=' + alias, 'needid': true }, res => {
                this.$emit("setcollegeid", res.infodata.id);
                this.infodata = res.infodata;
                this.sloganicon = res.infodataimg.imgs;

                this.$common.each(res.infodatalevel, (item) => {
                    item.x_children = res.infodatacourse.filter(item2 => item2.levelid == item.id);
                });
                this.$common.each(res.infodataproject, (item) => {
                    item.x_children = res.infodatalevel.filter(item2 => item2.projectid == item.id);
                    item.x_index = 0;
                });
                this.infolist = res.infodataproject;
            });
        }
    }
</script>
